import { IDataAlert } from '../types/IDataAlert';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IGroup } from '../types/IGroup';
import { IUser } from '../types/IUser';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetDataAlertsResult extends IGetItemsResult {
  dataAlerts: IDataAlert[];
  users: IUser[];
  groups: IGroup[];
}

export class GetDataAlertsRequest extends Request<IGetItemsParams, IGetDataAlertsResult> {
  constructor(params: IGetItemsParams) {
    super('getDataAlerts', params);
  }
}
